import { render, staticRenderFns } from "./UncheckedManualQuestionnaireAnswer.vue?vue&type=template&id=603845ef&scoped=true&"
import script from "./UncheckedManualQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
export * from "./UncheckedManualQuestionnaireAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./UncheckedManualQuestionnaireAnswer.vue?vue&type=style&index=0&id=603845ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603845ef",
  null
  
)

export default component.exports